export default "__VITE_ASSET__1e24dc77__"